<!-- Mobile Menu Overlay -->
<div class="mobile-menu-overlay" [class.open]="isOpen" (click)="onCloseClick()">
  <!-- Mobile Menu Drawer -->
  <div class="mobile-menu-drawer" [class.open]="isOpen" (click)="$event.stopPropagation()">
    <!-- Header with Close Button -->
    <div class="mobile-menu-header">
      <div class="mobile-menu-logo">
        <img src="assets/Botmaa-logo.png" alt="BotMaa Logo" />
      </div>
      <button class="mobile-menu-close" (click)="onCloseClick()" aria-label="Close menu">
        <lucide-angular [img]="X" [size]="24" color="#64748b"></lucide-angular>
      </button>
    </div>

    <!-- Menu Content -->
    <div class="mobile-menu-content">
      <!-- Top Menu Items -->
      <ul class="mobile-side-menu top-menu">
        @for (item of topMenuItems; track item.id || item.name) {
          @if (item.id && item.name && item.icon) {
            <li class="mobile-menu-item">
              @if (item.children && item.children.length > 0) {
                <!-- Parent Menu Item with Sub-menu -->
                <div
                  class="mobile-menu-link"
                  [ngClass]="{
                    active: isActive(item.id),
                    expanded: isExpanded(item.id),
                  }"
                  [style.background-color]="isActive(item.id) ? '#fff7ed' : 'transparent'"
                  (click)="handleMenuClick(item)"
                >
                  <lucide-angular
                    [color]="isActive(item.id) ? '#F9A138' : '#64748b'"
                    [size]="20"
                    [img]="item.icon"
                    class="mobile-menu-icon"
                  >
                  </lucide-angular>
                  <span class="mobile-menu-text" [style.color]="isActive(item.id) ? '#F9A138' : '#64748b'">{{ item.name }}</span>
                  <lucide-angular
                    [color]="isActive(item.id) ? '#F9A138' : '#64748b'"
                    [size]="16"
                    [img]="ChevronUp"
                    class="mobile-chevron-icon"
                    [ngClass]="{ rotated: isExpanded(item.id) }"
                  >
                  </lucide-angular>
                </div>
                <!-- Sub-menu Items -->
                @if (isExpanded(item.id)) {
                  <ul class="mobile-sub-menu">
                    @for (child of item.children; track child.id) {
                      <li class="mobile-sub-menu-item" [ngClass]="{ active: isSubTabActive(child.id) }">
                        <a
                          class="mobile-sub-menu-link"
                          [ngClass]="{ active: isSubTabActive(child.id) }"
                          (click)="handleMenuClick(item, child)"
                        >
                          <span>{{ child.name }}</span>
                        </a>
                      </li>
                    }
                  </ul>
                }
              } @else {
                <!-- Regular Menu Item -->
                @if (item.id === 'performance-stats') {
                  <a
                    class="mobile-menu-link"
                    [ngClass]="{ active: isActive(item.id) }"
                    [style.background-color]="isActive(item.id) ? '#fff7ed' : 'transparent'"
                    (click)="handleMenuClick(item)"
                  >
                    <lucide-angular
                      [color]="isActive(item.id) ? '#F9A138' : '#64748b'"
                      [size]="20"
                      [img]="item.icon"
                      class="mobile-menu-icon"
                    >
                    </lucide-angular>
                    <span class="mobile-menu-text" [style.color]="isActive(item.id) ? '#F9A138' : '#64748b'">{{ item.name }}</span>
                  </a>
                } @else {
                  <a
                    [routerLink]="'/' + item.id"
                    [routerLinkActive]="'active'"
                    [routerLinkActiveOptions]="{ exact: item.id !== 'performance-stats' && item.id !== 'broker-settings' }"
                    class="mobile-menu-link"
                    [ngClass]="{ active: isActive(item.id) }"
                    [style.background-color]="isActive(item.id) ? '#fff7ed' : 'transparent'"
                    (click)="onCloseClick()"
                  >
                    <lucide-angular
                      [color]="isActive(item.id) ? '#F9A138' : '#64748b'"
                      [size]="20"
                      [img]="item.icon"
                      class="mobile-menu-icon"
                    >
                    </lucide-angular>
                    <span class="mobile-menu-text" [style.color]="isActive(item.id) ? '#F9A138' : '#64748b'">{{ item.name }}</span>
                  </a>
                }
              }
            </li>
          }
        }
      </ul>

      <!-- Bottom Menu Items (Separator, Settings, etc.) -->
      <ul class="mobile-side-menu bottom-menu">
        @for (item of bottomMenuItems; track item.id || item.name || item.isSeparator) {
          @if (item.isSeparator) {
            <li class="mobile-menu-separator"></li>
          } @else if (item.id && item.name && item.icon) {
            <li class="mobile-menu-item">
              <a
                [routerLink]="item.id === 'logout' ? null : '/' + item.id"
                [routerLinkActive]="'active'"
                [routerLinkActiveOptions]="{ exact: true }"
                class="mobile-menu-link"
                [ngClass]="{ logout: item.id === 'logout', active: isActive(item.id) }"
                [style.background-color]="isActive(item.id) && item.id !== 'logout' ? '#fff7ed' : 'transparent'"
                (click)="item.id === 'logout' ? handleMenuClick(item) : onCloseClick()"
              >
                <lucide-angular
                  [color]="isActive(item.id) ? '#F9A138' : '#64748b'"
                  [size]="20"
                  [img]="item.icon"
                  class="mobile-menu-icon"
                >
                </lucide-angular>
                <span class="mobile-menu-text" [style.color]="isActive(item.id) ? '#F9A138' : '#64748b'">{{ item.name }}</span>
              </a>
            </li>
          }
        }
      </ul>
    </div>
  </div>
</div>

